import { useCallback, useEffect, useState } from 'react';

function getFullscreenElement(): Element | null {
    const d = document as any;
    return d.fullscreenElement ?? d.webkitFullscreenElement ?? null;
}

async function requestFullscreen() {
    const e = document.documentElement as any;
    if (e.requestFullscreen) return e.requestFullscreen();
    if (e.webkitRequestFullscreen) return e.webkitRequestFullscreen();
}

async function exitFullscreen() {
    const d = document as any;
    if (d.exitFullscreen) return d.exitFullscreen();
    if (d.webkitExitFullscreen) return d.webkitExitFullscreen();
}

export function useFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const isSupported =
        typeof document !== 'undefined' &&
        ('fullscreenEnabled' in document || 'webkitFullscreenEnabled' in (document as any));

    useEffect(() => {
        const onChange = () => setIsFullscreen(!!getFullscreenElement());
        document.addEventListener('fullscreenchange', onChange);
        document.addEventListener('webkitfullscreenchange', onChange);
        return () => {
            document.removeEventListener('fullscreenchange', onChange);
            document.removeEventListener('webkitfullscreenchange', onChange);
        };
    }, []);

    const toggle = useCallback(() => {
        if (getFullscreenElement()) {
            void exitFullscreen();
        } else {
            void requestFullscreen();
        }
    }, []);

    return { isFullscreen, toggle, isSupported };
}
